
const LOGO_URL = 'https://static.readdy.ai/image/d21c811a591cac7dc9306c593ec79059/f7e5252675c8f97538d8efad23113515.png';

export default function Header() {
  return (
    <header className="bg-white py-3 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 flex justify-center">
        <a href="#top" className="cursor-pointer">
          <div className="w-60 h-20 flex items-center justify-center">
            <img
              src={LOGO_URL}
              alt="Sunshine Air Pros - Professional Air Duct and Dryer Vent Cleaning"
              title="Sunshine Air Pros air duct cleaning dryer vent cleaning"
              className="w-full h-full object-contain"
            />
          </div>
        </a>
      </div>
    </header>
  );
}
